var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[_c('iframe',{class:_vm.eHeight?'has':'no',attrs:{"src":_vm.expertUrl,"width":"100%","border":"0","frameborder":"no"}}),_c('eFooter',{staticStyle:{"position":"fixed"},attrs:{"height":_vm.eHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }